"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ViewTransactionIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("rect", { x: "11.15", width: "1.7", height: "2.392" }),
        react_1.default.createElement("rect", { x: "11.15", y: "21.608", width: "1.7", height: "2.392" }),
        react_1.default.createElement("rect", { y: "11.15", width: "2.392", height: "1.7" }),
        react_1.default.createElement("rect", { x: "21.608", y: "11.15", width: "2.392", height: "1.7" }),
        react_1.default.createElement("path", { d: "M4.804,7.846v8.309l7.196,4.155,7.196-4.155V7.846L12,3.691,4.804,7.846Zm11.827,.482l-4.631,2.612-4.631-2.612,4.631-2.674,4.631,2.674Zm-10.127,1.464l4.646,2.621v5.443l-4.646-2.682v-5.381Zm6.346,8.064v-5.443l4.646-2.621v5.381l-4.646,2.682Z" })));
}
exports.default = ViewTransactionIcon;
